/** 
 * @description: 出货仓管理
 * @author: hwx
 */
<template>
    <div class="out-warehouse-manage">
        <!-- 出货仓列表 -->
        <div class="outst-list" v-show="showlist">
            <div class="row row-margin">
                <button type="button" class="btn btn-flat btn-middle btn-orange" @click="addOutst()">新增出货仓</button>
            </div>
            <div class="row">
                <label class="list-label-4">门店名称:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="outst_shop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-2">仓库:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="outst_stock" data-placeholder="请选择仓库" disabled>
                    </select>
                </div>
                <label class="list-label-2">名称:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入出货点名称" v-model="outst_name">
                </div>
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="queryList()">查询</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="outst_list"></table>
            </div>
        </div>
        <!-- 新增、修改出货仓 -->
        <div class="outst-edit" v-show="showdetail">
            <div class="page-tit">{{edit_tit}}</div>
            <div class="row">
                <label class="ctr-label-left">门店:</label>
                <div class="col-md-4 ct-col">
                    <select class="form-control" data-placeholder="请选择门店" ref="edit_shop">
                    </select>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">出货点名称:</label>
                <div class="col-md-4">
                    <input class="form-control" placeholder="请输入出货点名称" v-model="edit_name">
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">出货区域:</label>
                <div class="col-md-4">
                    <input class="form-control input-readonly" placeholder="请选择出货区域" v-model="edit_area_txt" ref="edit_area_txt" readonly @click="editAreaFun">
                    <span class="selection-clear" @click="clearInput('edit_area_txt')">×</span>
                    <span class="span-arrow" role="presentation">
                    <b role="presentation"></b></span>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">出货包厢:</label>
                <div class="col-md-4">
                    <input class="form-control input-readonly" placeholder="请选择出货包厢" v-model="edit_box_txt" ref="edit_box_txt" readonly @click="editBoxFun">
                    <span class="selection-clear" @click="clearInput('edit_box_txt')">×</span>
                    <span class="span-arrow" role="presentation">
                    <b role="presentation"></b></span>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">商品属性:</label>
                <div class="col-md-4">
                    <input class="form-control input-readonly" v-model="edit_attr_txt" ref="edit_attr_txt" placeholder="请选择商品属性" readonly @click="editAttrFun()">
                    <span class="selection-clear" @click="clearInput('edit_attr_txt')">×</span>
                    <span class="span-arrow" role="presentation">
                    <b role="presentation"></b></span>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">出货仓库:</label>
                <div class="col-md-4 ct-col">
                    <select class="form-control" ref="edit_stock" data-placeholder="请选择出货仓库">
                    </select>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">使用时间:</label>
                <div class="col-md-4">
                    <input class="form-control input-readonly" v-model="outst_use_time" ref="outst_use_time" placeholder="请选择使用时间" readonly @click="openUseTime()">
                    <span class="selection-clear" @click="clearInput('outst_use_time')">×</span>
                    <span class="span-arrow" role="presentation">
                        <b role="presentation"></b>
                    </span>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">出货收银机:</label>
                <div class="col-md-4">
                    <input class="form-control input-readonly" placeholder="请选择出货收银机" v-model="edit_cash_txt" ref="edit_cash_txt" readonly @click="editCashFun($event)" />
                    <span class="selection-clear" @click="clearInput('edit_cash_txt')">×</span>
                    <span class="span-arrow" role="presentation">
                    <b role="presentation"></b></span>
                </div>
                <p>注：若设置了出货收银机后只能该指定的收银机出品才从当前出货仓出库，一般用于一个场所有两个超市无特定区域管辖情况下则需设置此操作来区分两个超市的出货仓，其余情况默认不设置。</p>
            </div>
            <div class="row">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backFun">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="editOutst(modify)">保存</button>
            </div>
        </div>
        <!-- 出货区域 -->
        <div class="ele-hide" ref="area_alert">
            <div class="sel-seldiv">
                <ul class="set-area clearfix">
                    <li>
                        <input type='checkbox' v-model='area_all' @click='areaCheckAll'>
                        <span>全选</span>
                    </li>
                    <li v-for="item in area_arr">
                        <input type="checkbox" v-model='area_item' :value="item.id">
                        <span>{{item.name}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 出货包厢 -->
        <div v-show="showbox">
            <div class="page-tit">出货仓包厢范围</div>
            <p>请选择出货仓包厢范围</p>
            <div class="box-area-main row-margin">
                <div class="goods_checkboxdiv box_area" v-for="items in box_arr">
                    <div class="first">
                        <span>{{items.room_area_name}}</span>
                    </div>
                    <ul class="clearfix">
                        <li v-for="item in items.room">
                            <input type="checkbox" v-model='box_item' :value="item.id">
                            <span>{{item.name}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="boxBack()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="boxSub()">确定</button>
            </div>
        </div>
        <!-- 商品属性 -->
        <div class="ele-hide" ref="attr_alert">
            <div class="multi-select">
                <div class="clearfix">
                    <input type='checkbox' v-model='attr_all' @click='attrCheckAll'>
                    <span>全选</span>
                </div>
                <ul class="clearfix">
                    <li v-for="item in attr_arr">
                        <input type="checkbox" v-model='attr_item' :value="item.id">
                        <span>{{item.name}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 使用时间弹窗 -->
        <div class="outst-usetime-pop">
            <div class="chooseTime_popup-wrap">
                <div class="chooseTime_popup_title">开始时间：</div>
                <select ref="starthour"></select>
                <label class="colon">:</label>
                <select ref="startseconds"></select>
                <div class="chooseTime_popup_title">结束时间：</div>
                <select ref="stophour" id="stophour"></select>
                <label class="colon">:</label>
                <select ref="stopseconds"></select>
            </div>
        </div>
        <!-- 出货收银机 -->
        <div class="outst-cash-wrap" ref="outst_cash_wrap">
            <ul>
                <li>
                    <input type="checkbox" id="pall" v-model='outst_cash_all' @click="outstCashSelAll">
                    <label for="pall">全选</label>
                </li>
                <li v-for="item in outst_cash_arr">
                    <input type="checkbox" :id="item.id" v-model="outst_cash_item" :value="item.id">
                    <label :for="item.id">{{item.name}}</label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    export default {
        name: 'printer_manage',
        data() {
            return {
                showlist: true,
                showdetail: false,
                modify: 1,
                showbox: false,

                outst_name: "",

                theDet: {
                    type: Object
                },
                edit_tit: "新增出货仓库",
                edit_name: "",
                edit_area_txt: "",
                area_all: false,
                c_area_all: false,
                area_item: [],
                area_arr: [],
                edit_box_txt: "",
                box_item: [],
                box_arr: [],
                box_arr_det: [],
                edit_attr_txt: "",
                attr_all: false,
                c_attr_all: false,
                attr_item: [],
                attr_arr: [],
                start_usetime: '',
                end_usetime: '',
                edit_cash_txt: '',
                outst_cash_all: false,
                c_outst_cash_all: false,
                outst_cash_arr: [],
                outst_cash_item: [],
            }
        },
        computed: {
            outst_use_time() {
                return this.start_usetime + "-" + this.end_usetime;
            }
        },
        watch: {
            edit_area_txt: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.edit_box_txt).prop('disabled', true);
                        $(this.$refs.edit_area_txt).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.edit_box_txt).prop('disabled', false);
                        $(this.$refs.edit_area_txt).parent().find('.selection-clear').hide();
                        this.area_item = [];
                    }
                },
                deep: true
            },
            area_item: {
                handler: function(val, oldVal) {
                    if(this.area_item.length >= this.area_arr.length) {
                        this.area_all = true;
                        this.c_area_all = true;
                    } else {
                        this.area_all = false;
                        this.c_area_all = false;
                    }
                },
                deep: true
            },
            edit_box_txt: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.edit_area_txt).prop('disabled', true);
                        $(this.$refs.edit_box_txt).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.edit_area_txt).prop('disabled', false);
                        $(this.$refs.edit_box_txt).parent().find('.selection-clear').hide();
                        this.box_item = [];
                    }
                },
                deep: true
            },
            edit_attr_txt: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.edit_attr_txt).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.edit_attr_txt).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
            attr_item: {
                handler: function(val, oldVal) {
                    if(this.attr_item.length >= this.attr_arr.length) {
                        this.attr_all = true;
                        this.c_attr_all = true;
                    } else {
                        this.attr_all = false;
                        this.c_attr_all = false;
                    }
                },
                deep: true
            },
            outst_cash_item: {
                handler: function(val, oldVal) {
                    if(this.outst_cash_item.length >= this.outst_cash_arr.length) {
                        this.outst_cash_all = true;
                        this.c_outst_cash_all = true;
                    } else {
                        this.outst_cash_all = false;
                        this.c_outst_cash_all = false;
                    }
                },
                deep: true
            }
        },
        mounted: function() {
            this.$nextTick(function() {
                this.getshopdata();
                $(this.$refs.list_state).select2({
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
            });
            this.initi_list_box('');
            this.selectTime();

            this.getGoodsAttr();
        },
        methods: {
            // 门店数据
            getshopdata: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let arr = [];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.outst_shop).select2({
                                data: arr,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    _this.initi_list_box('');
                                    $(_this.$refs.outst_stock).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.outst_stock).prop("disabled", false);
                                _this.getShopStock(e.params.data.id, 'list');
                            });
                            $(_this.$refs.outst_shop).val(data.response.result[1].id).trigger('change');
                            $(_this.$refs.outst_stock).prop("disabled", false);
                            _this.getShopStock(data.response.result[1].id, 'list');
                            _this.innitable();

                            arr.shift();
                            $(_this.$refs.edit_shop).select2({
                                data: arr,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select", function(e) {
                                // 出货区域
                                _this.getShopArea(e.params.data.id);
                                _this.edit_area_txt = '';
                                _this.area_item = [];
                                // 出货包厢
                                _this.getShopRoom(e.params.data.id);
                                _this.edit_box_txt = '';
                                _this.box_item = [];
                                // 出货仓库
                                _this.getShopStock(e.params.data.id);
                                // 出货收银机
                                _this.getCashData();
                                _this.edit_cash_txt = '';
                                _this.outst_cash_item = [];
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            // 仓库数据
            getShopStock: function(shop_id, type) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getStoreList",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            if(type == 'list') {
                                _this.initi_list_box(arr);
                                return;
                            }
                            arr.shift();
                            $(_this.$refs.edit_stock).html("");
                            $(_this.$refs.edit_stock).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            initi_list_box: function(arr) {
                $(this.$refs.outst_stock).html("");
                $(this.$refs.outst_stock).select2({
                    data: arr,
                    minimumResultsForSearch: -1,
                    language: "zh-CN",
                    width: '100%'
                });
            },
            // 出货仓列表
            innitable: function() {
                let _this = this;
                let actionEvents = {
                    'click .status': function(e, value, row, index) {
                        let statustxt = "";
                        if(row.status == 1) {
                            statustxt = "确认禁用【"+ row.name +"】吗?"
                        } else {
                            statustxt = "确认启用【"+ row.name +"】吗?"
                        }
                        layer.confirm(statustxt, {
                            btn: ['确定', '取消']
                        }, function() {
                            let datas = {
                                "header": Vue.request_header,
                                "request": {
                                    "param": {
                                        "id": row.id
                                    }
                                },
                                "comment": ""
                            };
                            datas = JSON.stringify(datas);
                            $.ajax({
                                type: "POST",
                                dataType: "json",
                                url: Vue.ctUrl + "Store/setStoreProduceStatus",
                                async: false,
                                crossDomain: true,
                                xhrFields: {
                                    withCredentials: true
                                },
                                data: datas,
                                success: function(data) {
                                    if(data['response']['result_code'] == "true") {
                                        layer.msg(data["response"]["error_msg"]);
                                        
                                        _this.innitable();
                                    } else {
                                        Vue.timeoutfun(data.response.result_status, _this);
                                        layer.msg(data["response"]["error_msg"]);
                                    }
                                },
                                error: function(err) {
                                    layer.msg("出错啦");
                                }
                            });
                        });
                    },
                    'click .update': function(e, value, row, index) {
                        _this.modify = 2;
                        _this.edit_tit = "修改出货仓";
                        _this.getOutstDet(row.id);
                        _this.showlist = false;
                        _this.showdetail = true;
                    },
                    'click .delete': function(e, value, row, index) {
                        layer.confirm('确认删除' + row.name + '吗？', {
                            btn: ['确定', '取消']
                        }, function() {
                            _this.deleteProd(row.id);
                        });
                    }
                };
                $(_this.$refs.outst_list).bootstrapTable("destroy");
                $(_this.$refs.outst_list).bootstrapTable({
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "10%"
                    }, {
                        field: "name",
                        title: "出货点名称",
                        width: "10%"
                    }, {
                        field: "room_area_name",
                        title: "区域",
                        width: "12%"
                    }, {
                        field: "room_name",
                        title: "包厢号",
                        width: "15%",
                        class: "room-info-td"
                    }, {
                        field: "goods_type_name",
                        title: "商品属性",
                        width: "15%"
                    }, {
                        field: "store_name",
                        title: "仓库",
                        width: "10%"
                    }, {
                        field: "store_name",
                        title: "状态",
                        width: "10%",
                        formatter: function(value, row, index) {
                            if(row.status == '1') {
                                return '启用中';
                            } else {
                                return '禁用中';
                            }
                        }
                    }, {
                        width: "12%",
                        title: "操作",
                        events: actionEvents,
                        formatter: function(value, row, index) {
                            let status_name = (row.status == 1) ? "禁用" : "启用";
                            return '<span class="text-blue status">'+ status_name +'</span><span class="text-blue update">修改</span><span class="text-blue delete">删除</span>';
                        }
                    }],
                });
            },
            getList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "shop_id": $(_this.$refs.outst_shop).val(),
                            "store_id": $.trim($(_this.$refs.outst_stock).val()),
                            "name": _this.outst_name
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "store/getStoreProduceList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            params.success({
                                total: data['response']['result']['total'],
                                rows: data['response']['result']['rows']
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            // 点击查询
            queryList: function() {
                this.innitable();
            },
            // 点击新增出货仓
            addOutst: function(params) {
                this.modify = 1;
                this.edit_tit = "新增出货仓";
                $(this.$refs.edit_shop).prop("disabled", false);
                $(this.$refs.edit_shop).val('').trigger('change');
                this.edit_name = "";
                this.getShopArea($(this.$refs.edit_shop).val());
                $(this.$refs.edit_area_txt).prop('disabled', false);
                this.edit_area_txt = "";
                this.area_item = [];
                this.getShopRoom($(this.$refs.edit_shop).val());
                $(this.$refs.edit_box_txt).prop('disabled', false);
                this.edit_box_txt = "";
                this.box_item = [];
                this.edit_attr_txt = "";
                this.attr_item = [];
                this.getShopStock($(this.$refs.edit_shop).val());
                this.start_usetime = '';
                this.end_usetime = '';
                this.edit_cash_txt = '';
                this.outst_cash_item = [];
                this.getCashData();

                this.showlist = false;
                this.showdetail = true;
            },
            // 清空选项
            clearInput: function(name) {
                if(name == "edit_box_txt") {
                    this.edit_box_txt = "";
                } else if(name == "edit_area_txt") {
                    this.edit_area_txt = "";
                } else if(name == "edit_attr_txt") {
                    this.edit_attr_txt = "";
                    this.attr_item = [];
                } else if(name == "outst_use_time") {
                    this.outst_use_time = "";
                } else if(name == "edit_cash_txt") {
                    this.edit_cash_txt = "";
                }
            },
            // 点击选择出货区域
            editAreaFun: function() {
                let _this = this;
                let c_area_item = _this.area_item;
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], //按钮
                    title: ['出货区域', true],
                    area: ['300px', ''], //宽高
                    content: $(this.$refs.area_alert),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.edit_area_txt != "") {
                            _this.area_item = c_area_item;
                            return;
                        }
                        _this.area_item = [];
                    }
                }, function() {
                    let texts = [];
                    _this.area_arr.forEach(function(item) {
                        _this.area_item.forEach(function(item2) {
                            if(item.id == item2) {
                                texts.push(item.name);
                            }
                        });
                    });
                    _this.edit_area_txt = texts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.edit_area_txt != "") {
                        _this.area_item = c_area_item;
                        return;
                    }
                    _this.area_item = [];
                });
            },
            // 获取出货区域
            getShopArea: function(shopid) {
                let _this = this;
                
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shopid
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getRoomArea",
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            _this.area_arr = data['response']['result'];
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            // 出货区域全选
            areaCheckAll: function() {
                let _this = this;

                _this.area_all = _this.c_area_all;
                if(!_this.area_all) { // 实现全选
                    _this.area_item = [];
                    _this.area_arr.forEach(function(item) {
                        _this.area_item.push(item.id);
                    });
                } else { // 实现反选
                    this.area_item = [];
                }
            },
            // 点击选择出货包厢
            editBoxFun: function() {
                this.showdetail = false;
                this.showbox = true;
            },
            // 出货包厢数据
            getShopRoom: function(shopid) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shopid
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoomByArea",
                    async:false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code']=="true"){
                            _this.box_arr = data['response']['result'];
                            let arr = [];
                            $.each(data['response']['result'], function(k, v) {
                                $.each(v.room, function(m, n) {
                                    arr.push(n);
                                });
                            });
                            _this.box_arr_det = arr;
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            // 选择出货包厢
            boxSub: function() {
                let _this = this;
                let texts = [];
                _this.box_arr_det.forEach(function(item) {
                    _this.box_item.forEach(function(item2) {
                        if(item.id == item2) {
                            texts.push(item.name);
                        }
                    });
                });
                _this.edit_box_txt = texts.join(",");
                _this.showdetail = true;
                _this.showbox = false;
            },
            // 返回
            boxBack: function() {
                this.showdetail = true;
                this.showbox = false;
            },
            // 点击选择商品属性
            editAttrFun: function(e) {
                let _this = this;
                let c_attr_item = _this.attr_item;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], //按钮
                    title: ['商品属性', true],
                    area: ['700px', ''], //宽高
                    content: $(_this.$refs.attr_alert),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.edit_attr_txt != "") {
                            _this.attr_item = c_attr_item;
                            return;
                        }
                        _this.attr_item = [];
                    }
                }, function() {
                    var texts = [];
                    _this.attr_arr.forEach(function(item) {
                        _this.attr_item.forEach(function(item2) {
                            if(item.id == item2) {
                                texts.push(item.name);
                            }
                        });
                    });
                    _this.edit_attr_txt = texts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.edit_attr_txt != "") {
                        _this.attr_item = c_attr_item;
                        return;
                    }
                    _this.attr_item = [];
                });
            },
            // 商品属性数据
            getGoodsAttr: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {}
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getGoodsType",
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true"){
                            _this.attr_arr = data['response']['result']['data'];
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {

                    }
                });
            },
            // 商品属性全选
            attrCheckAll: function() {
                let _this = this;
                _this.attr_all = _this.c_attr_all;
                if(!_this.attr_all) { // 实现全选
                    _this.attr_item = [];
                    _this.attr_arr.forEach(function(item) {
                        _this.attr_item.push(item.id);
                    });
                } else { // 实现反选
                    _this.attr_item = [];
                }
            },
            // 打开选择时间
            openUseTime: function() {
                let _this = this;
                if(_this.start_usetime != '') {
                    $(_this.$refs.starthour).val(_this.start_usetime.split(':')[0]).trigger('change');
                    $(_this.$refs.startseconds).val(_this.start_usetime.split(':')[1]).trigger('change');
                    $(_this.$refs.stophour).val(_this.end_usetime.split(':')[0]).trigger('change');
                    $(_this.$refs.stopseconds).val(_this.end_usetime.split(':')[1]).trigger('change');
                }
                layer.confirm('', {
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: '使用时间选择',
                    area: ['450px', ''], // 宽高
                    content: $('.outst-usetime-pop')
                }, function() {
                    _this.createTimeString();
                    layer.closeAll();
                });
            },
            // 获取选择的时间
            createTimeString() {
                let _this = this;
                let starthour = $(_this.$refs.starthour).select2("val");
                let startseconds = $(_this.$refs.startseconds).select2("val");
                let stophour = $(_this.$refs.stophour).select2("val");
                let stopseconds = $(_this.$refs.stopseconds).select2("val");
                _this.start_usetime = starthour + ":" + startseconds;
                _this.end_usetime = stophour + ":" + stopseconds;
            },
            // 获取时间
            selectTime: function() {
                let _this = this;
                let seconds = [];
                for(let i = 0; i < 60; i++) {
                    let item = {};
                    item.id = (i < 10) ? '0' + i : i;
                    item.text = (i < 10) ? '0' + i : i;
                    seconds[i] = item;
                };
                let hour = [];
                for(let i = 0; i < 24; i++) {
                    let item = {};
                    item.id = (i < 10) ? '0' + i : i;
                    item.text = (i < 10) ? '0' + i : i;
                    hour[i] = item;
                }
                $(_this.$refs.starthour).select2({
                    data: hour,
                    language: "zh-CN"
                });
                $(_this.$refs.startseconds).select2({
                    data: seconds,
                    language: "zh-CN"
                });
                $(_this.$refs.stophour).select2({
                    data: hour,
                    language: "zh-CN"
                });
                $(_this.$refs.stopseconds).select2({
                    data: seconds,
                    language: "zh-CN"
                })
            },
            // 点击选择收银机
            editCashFun: function() {
                let _this = this;
                let c_outst_cash_item = _this.outst_cash_item;
                
                layer.confirm('', {
                    skin: '',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择收银机', true],
                    area: ['500px', ''], // 宽高
                    content: $(_this.$refs.outst_cash_wrap),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.edit_cash_txt != "") {
                            _this.outst_cash_item = c_outst_cash_item;
                            return;
                        }
                        _this.outst_cash_item = [];
                    }
                }, function() {
                    let texts = [];
                    _this.outst_cash_arr.forEach(function(item) {
                        _this.outst_cash_item.forEach(function(item2) {
                            if(item.id == item2) {
                                texts.push(item.name);
                            }
                        });
                    });
                    _this.edit_cash_txt = texts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.edit_cash_txt != "") {
                        _this.outst_cash_item = c_outst_cash_item;
                        return;
                    }
                    _this.outst_cash_item = [];
                });
            },
            // 获取收银机列表
            getCashData: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": $(_this.$refs.edit_shop).val()
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getShopCheckstandListByPrinter",
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.outst_cash_arr = data['response']['result'];
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 收银机全选
            outstCashSelAll: function() {
                let _this = this;
                
                _this.outst_cash_all = _this.c_outst_cash_all;
                if(!_this.outst_cash_all) { // 实现全选
                    _this.outst_cash_item = [];
                    _this.outst_cash_arr.forEach(function(item) {
                        _this.outst_cash_item.push(item.id);
                    });
                } else { // 实现反选
                    _this.outst_cash_item = [];
                }
            },
            // 返回列表
            backFun: function() {
                this.showlist = true;
                this.showdetail = false;
            },
            // 提交新增、修改的
            editOutst: function(status) {
                let _this = this;
                
                if(_this.edit_name == '') {
                    layer.msg('请输入出货点名称');
                    return;
                } else if(_this.edit_area_txt == '' && _this.edit_box_txt == '') {
                    layer.msg('请选择出货区域或出货包厢');
                    return;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id":$(_this.$refs.edit_shop).val(),
                            "name": _this.edit_name,
                            "room_area": _this.area_item,
                            "room_id": _this.box_item,
                            "goods_type": _this.attr_item,
                            "store_id": $(_this.$refs.edit_stock).val(),
                            "use_start_time": _this.start_usetime,
                            "use_end_time": _this.end_usetime,
                            "checkstand_id": _this.outst_cash_item
                        }
                    },
                    "comment": ""
                };
                let pathurl = "";
                if(status == "1") {
                    pathurl = 'addStoreProduce';
                } else {
                    pathurl = 'updateStoreProduce';
                    datas["request"]["param"]["id"] = this.theDet.id;
                }
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "store/" + pathurl,
                    async:false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            layer.msg(data["response"]["error_msg"]);
                            $(_this.$refs.outst_list).bootstrapTable("refresh");
                            _this.showlist = true;
                            _this.showdetail = false;
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            // 获取详情
            getOutstDet: function(id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": id,
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "store/getStoreProduceDetail",
                    async:false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            var datas = data['response']['result'];
                            _this.theDet = datas;
                            
                            // 门店
                            $(_this.$refs.edit_shop).prop("disabled", true);
                            $(_this.$refs.edit_shop).val(datas.shop_id).trigger("change");
                            // 出货点名称
                            _this.edit_name = datas.name;
                            // 出货区域
                            _this.getShopArea(datas.shop_id);
                            _this.edit_area_txt = datas.room_area_name;
                            _this.area_item = datas.room_area;
                            // 出货包厢
                            _this.getShopRoom(datas.shop_id);
                            _this.edit_box_txt = datas.room_name;
                            _this.box_item = datas.room_id;
                            // 包厢区域二选一
                            if(datas.room_area_name != "") {
                                $(_this.$refs.edit_area_txt).prop('disabled', false);
                                $(_this.$refs.edit_box_txt).prop('disabled', true);
                            } else {
                                $(_this.$refs.edit_area_txt).prop('disabled', true);
                                $(_this.$refs.edit_box_txt).prop('disabled', false);
                            }
                            _this.edit_attr_txt = datas.goods_type_name;
                            _this.attr_item = datas.goods_type;
                            // 出货仓库
                            _this.getShopStock(datas.shop_id);
                            $(_this.$refs.edit_stock).val(datas.store_id).trigger('change');
                            // 使用时间
                            _this.start_usetime = datas.use_start_time;
                            _this.end_usetime = datas.use_end_time;
                            // 收银机
                            _this.getCashData();
                            _this.outst_cash_item = datas.checkstand_id;
                            _this.edit_cash_txt = datas.checkstand_name;
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {

                    }
                });
            },
            // 删除供应商
            deleteProd: function(id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/delStoreProduce",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        layer.closeAll();
                        if(data.response.result_code == "true") {
                            layer.msg("删除成功！");
                            $(_this.$refs.outst_list).bootstrapTable("refresh");
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.closeAll();
                        layer.msg("出错啦");
                    }
                });
            }
        }
    }
</script>
<style lang="less">
    .out-warehouse-manage {
        .outst-list {
            table .room-info-td {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        .outst-edit {
            p {
                position: relative;
                top: -23px;
                clear: both;
                color: #F00;
            }
        }
        .box-area-main {
            width: 80%;
            border: 1px solid #e5e5e5;
            margin-top: 20px;
        }
        .box-area {
            width: 100%;
            margin:0!important;
            padding:0px!important;
        }
        .box-area ul {
            margin-bottom: 0px;
            border:none;
        }
        .box-area .first {
            border:none;
        }

        .outst-usetime-pop {
            display: none;
            .chooseTime_popup-wrap {
                padding: 20px 60px;
                .chooseTime_popup_title {
                    overflow: hidden;
                    font-size: 16px;
                    color: #333;
                    margin: 10px;
                    div {
                        float: right;
                        label {
                            font-weight: normal;
                        }
                    }
                }
                .select2 {
                    width: 150px!important;
                }
                .select2-selection--single {
                    height: 46px;
                    line-height: 46px;
                    border-radius: 0!important;
                    outline: none;
                    border: 1px solid #d5d5d5!important;
                    .select2-selection__rendered {
                        line-height: 46px;
                        color: #9d9d9d;
                        font-size: 20px;
                    }
                    .select2-selection__arrow {
                        height: 46px;
                        line-height: 46px;
                    }
                }
                .colon {
                    width: 18px;
                    text-align: center;
                    line-height: 45px;
                    font-size: 20px;
                    color: #9d9d9d;
                    margin-bottom: 0px;
                }
            }
        }
        .outst-cash-wrap {
            display: none;
            padding: 30px 20px;
            font-size: 14px;
            ul {
                width: 27%;
                margin: 0 auto;
                li {
                    margin: 0 0 15px;
                }
                label {
                    margin: 0 0 0 6px;
                }
            }
        }
    }
</style>